import React, { useState, useEffect } from 'react'
import callPostApi from 'requests/PostRequests';
import * as Constants from '../../../requests/URLConstants';
import DashboardLineChart from '../DashboardLineChart';
import DashboardTable from '../DashboardTable';
import moment from 'moment';
import * as DashboardUtils from '../DashboardUtils.js';
import TableToolbarDownload from '../../../common/TableToolbarDownload';
import * as QueueTables from './tableHeaders';
import * as config from "../../../config/Constants";
import * as DashboardConstants from '../DashboardConstants';
import DashboardSummary from '../DashboardSummaryNew';
import { TableToolbar, TableToolbarContent, TableToolbarSearch } from 'carbon-components-react';
import axios from "axios";

require("./_queue-performance.scss");
const QueuePerformance = (props) => {
    const [QueuePerformanceTableLoading, setQueuePerformanceTableLoading] = useState(true);
    const [AccuracyReportTrendLoading, setAccuracyReportTrendLoading] = useState(true);
    const [performanceTrendLoading, setPerformanceTrendLoading] = useState(true);
    const [performanceTrendTableData, setPerformanceTrendTableData] = useState([]);
    const [queueformanceTableData, setQueueformanceTableData] = useState([]);
    const [searchedQueuePerformanceData, setSearchedQueuePerformanceData] = useState([]);
    const [searchedQueueValue, setSearchedQueueValue] = useState('');

    useEffect(() => {
        getAccuracyReportTrend(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getQueuePerformanceData(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);

    }, [props.preferencesChanged])

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {

        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();

        let bodyJSON = {
            "filters": {
                "time": {
                    "startDateTime": timeFilterSelections.startDateTime,
                    "endDateTime": timeFilterSelections.endDateTime
                },
                "franchises": dashboardFilterSelectionsAutomation.franchise,
                "clients": dashboardFilterSelectionsAutomation.client,
                "technologies": dashboardFilterSelectionsAutomation.technology,
                "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
                "business_competencies": dashboardFilterSelectionsAutomation.competency,
                "automata_priority": dashboardFilterSelectionsAutomation.priority,
                "status": dashboardFilterSelectionsAutomation.status,
                "automata_state": dashboardFilterSelectionsAutomation.automata_state,
                "queueName": dashboardFilterSelectionsAutomation.queue_name,
                "job_id": dashboardFilterSelectionsAutomation.job_id,
                "itemStatus_A1": dashboardFilterSelectionsAutomation.itemStatus_A1,
                "automata_name": dashboardFilterSelectionsAutomation.automata_name,
                "bot_id": dashboardFilterSelectionsAutomation.bot_id,
                "buisness_component": dashboardFilterSelectionsAutomation.buisness_component,
                "process_name": dashboardFilterSelectionsAutomation.process_name
            },
            "interval": {
                "calender_Interval": calenderInterval,
                "time_zone": timeZone
            }
        };
        return bodyJSON;
    };
    const preparePerformanceTrendData = (response) => {
        let tableData = [];
        let tableObj = {};
        if (response) {
            let buckets = response.aggregations.AutomataName.buckets;
            for (let i = 0; i < buckets.length; i++) {
                let botvalue = ((buckets[i].CompletedItem.value + buckets[i].BusinessException.value) / (buckets[i].CompletedItem.value + buckets[i].SystemException.value + buckets[i].BusinessException.value)) * 100
                let sum = 0;
                sum = sum + buckets[i].CompletedItem.value + buckets[i].ItemPending.value + buckets[i].running.value + buckets[i].BusinessException.value + buckets[i].SystemException.value;
                tableObj = {
                    id: i + 1,
                    ProcessName: buckets[i].key,
                    NoofItem: buckets[i].doc_count,
                    ItemPending: buckets[i].ItemPending.value,
                    CompletedItem: buckets[i].CompletedItem.value,
                    SystemException: buckets[i].SystemException.value,
                    AvgHandlingTime: buckets[i].AvgHandlingTime.value,
                    BusinessException: buckets[i].BusinessException.value,
                    AvgProcessingTime: buckets[i].AvgProcessingTime.value,
                    running: buckets[i].running.value,
                    Others: buckets[i].doc_count - sum,
                    botaccuracy: botvalue ? botvalue.toFixed(2) + '%' : '-'
                };
                tableData.push(tableObj);
            }
        }
        return { tableData };
    };

    const getAccuracyReportTrend = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setAccuracyReportTrendLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETQUEUEACCURACYREPORT, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = preparePerformanceTrendData(resp);
                    setPerformanceTrendTableData(formattedData.tableData);
                    setAccuracyReportTrendLoading(false);
                }).catch((error) => {
                    setAccuracyReportTrendLoading(false);
                });
        }
    }

    const getQueuePerformanceData = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setQueuePerformanceTableLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            axios.all([callPostApi(Constants.GETQUEUEPERFORMANCE, {
                'Content-Type': 'application/json'
            }, bodyJSON).then(response => {
                return response;
            }),
            callPostApi(Constants.GETAVERAGERETRIES, {
                'Content-Type': 'application/json'
            }, bodyJSON).then(response => {
                if (response) {
                    return response.aggregations.QueueName.buckets ? response.aggregations.QueueName.buckets : [];
                }
            })]).then(axios.spread((queuePerformanceResp, avgRetriesResp) => {
                formattedData = prepareQueuePerformanceData(queuePerformanceResp, avgRetriesResp);
                setQueueformanceTableData(formattedData.tableData);
                setQueuePerformanceTableLoading(false);
            })).catch((error) => {
                setQueuePerformanceTableLoading(false);
            });
        }
    }

    const prepareQueuePerformanceData = (queuePerformanceResp, avgRetriesResp) => {
        let tableData = [];
        let tableObj = {};
        if (queuePerformanceResp) {
            let buckets = queuePerformanceResp.aggregations.QueueName.buckets;
            for (let i = 0; i < buckets.length; i++) {
                let averageRetries = avgRetriesResp ? avgRetriesResp.filter(a => a.key === buckets[i].key)[0] : [];
                tableObj = {
                    id: i + 1,
                    QueueName: buckets[i].key,
                    AvgProcessTime: (buckets[i]["1"].value / 60).toFixed(3),
                    AvgHandlingTime: (buckets[i].AvgHandlingTime.value / 60).toFixed(3),
                    Avgretries: averageRetries && averageRetries.Avgretries && averageRetries.Avgretries.value ? averageRetries.Avgretries.value.toFixed(3) : 0
                };
                tableData.push(tableObj);
            }
        }
        return { tableData };
    };

    const searchTable = (e, reportType) => {
        let searchString = e.toUpperCase();
        let searchResult = [];
        let newList = [];
        let string, pattern;
        let matchedStrings;
        let queueReportData = queueformanceTableData;
        if (searchString) {
            newList = queueReportData.filter((element) => {
                for (var property in element) {
                    if (element.hasOwnProperty(property)) {
                        if (element[property] && property !== "id") {
                            string = element[property];
                        } else string = '';
                        string = string ? string.toString() : "";
                        pattern = new RegExp("(\\w*" + searchString + "\\w*)", "gi");
                        matchedStrings = string.match(pattern);
                        if (matchedStrings && matchedStrings.length) {
                            searchResult = searchResult.concat([element]);
                            return searchResult;
                        }
                    }
                }
            });
            setSearchedQueuePerformanceData(newList);

        } else {
            setSearchedQueuePerformanceData([]);
        }
    };

    return (
        <div className="top-margin dashboard queue-performance">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-charts-container">
                    {/* <div className="report-title">
                        <div className="carbon-display-Semibold-16">{DashboardConstants.QueueEfficiency}</div>
                    </div> */}
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.AutomataAccuracyReport}</div>
                            <div className="download-button">
                                <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={performanceTrendTableData} headers={QueueTables.performanceTrendHeaders} title={DashboardConstants.AutomataAccuracyReport} filename={DashboardConstants.AutomataAccuracyReport} label={DashboardConstants.Download} />
                            </div>
                        </div>
                        <div className="bold-border-table">
                            <DashboardTable loading={AccuracyReportTrendLoading} rows={performanceTrendTableData} headers={QueueTables.performanceTrendHeaders}
                                showPagination={true} isSortingAllowed={true} />
                        </div>
                    </section>
                    <div> {config.URL.includes(config.unilever) ? '' :
                        <section className="border-bottom performance-table">
                            <div className="graph-title carbon-display-Regular-20" style={{ marginTop: '30px' }}>
                                <div>{DashboardConstants.QueuePerformance}</div>
                                <div className="table-toolbar">
                                    <TableToolbar>
                                        <TableToolbarContent>
                                            <TableToolbarSearch onChange={(e) => { setSearchedQueueValue(e.target.value); searchTable(e.target.value, "performanceReport") }} className="search-button" />
                                        </TableToolbarContent>
                                    </TableToolbar>
                                    <div className="download-button">
                                        <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={queueformanceTableData} headers={QueueTables.queuePerformanceHeaders} title={DashboardConstants.QueuePerformance} filename={DashboardConstants.QueuePerformance} label={DashboardConstants.Download} />
                                    </div>
                                </div>
                            </div>
                            <div className="bold-border-table nested-table">
                                <DashboardTable loading={QueuePerformanceTableLoading} rows={searchedQueueValue.length ? searchedQueuePerformanceData : queueformanceTableData} headers={QueueTables.queuePerformanceHeaders}
                                    showPagination={true} isSortingAllowed={true} />
                            </div>
                        </section>
                    }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QueuePerformance;
